export default "__VITE_ASSET__jjW5AJlW__"